import React from 'react';
import createReactClass from 'create-react-class';
import BaseMixin from './BaseMixin';

const Paren = createReactClass({
  displayName: 'Paren',
  mixins: [BaseMixin],

  render: function() {
    return (
      <div className="paren">
        {this.props.node.get('terminal')}
      </div>
    );
  }
});

export default Paren;
